// Static content for S.V.P.INFRA marketing site

export const COMPANY = {
  name: "S.V.P.INFRA",
  shortName: "SVP",
  proprietor: "Jayaram Prabhakar",
  established: 2010,
  tagline: "Building Infrastructure with Integrity, Innovation, and Excellence.",
  address:
    "131, 8th A, Main Road, 4th Block, 4th Stage, Basaveshwaranagara, Bengaluru Urban, Karnataka 560079",
  phones: ["+91 98452 89937", "+91 63606 25328"],
  email: "likith@svpinfra.com",
  gstin: "29AHKPP6173E1ZY",
  plant: {
    type: "Asphalt Plant — Owned",
    address:
      "Sy. No. 130/2, S. Bingipura Village, Jigani Hobli, Anekal Taluk, Bengaluru – 562 106",
  },
};

export const SERVICES = [
  {
    code: "01",
    title: "Road Construction",
    desc: "Bituminous & concrete road execution — from sub-grade prep to wearing course, finished to IS-code specifications.",
    tags: ["Bituminous", "Concrete", "Resurfacing"],
  },
  {
    code: "02",
    title: "Paver & Kerbstone Works",
    desc: "Footpaths, kerbstones, cobblestones and interlocking paver block installation for campuses, malls and townships.",
    tags: ["Footpaths", "Cobblestone", "Interlocking"],
  },
  {
    code: "03",
    title: "Granite Supply & Installation",
    desc: "Direct quarry sourcing and precision installation of granite for kerbs, plazas, façades and pavements.",
    tags: ["Quarry-direct", "Cutting", "Polishing"],
  },
  {
    code: "04",
    title: "Sewerage & Drainage",
    desc: "Sewerage networks, manholes, and underground drainage execution with full QA/QC traceability.",
    tags: ["Networks", "Manholes", "Pipes"],
  },
  {
    code: "05",
    title: "Stormwater Management",
    desc: "Storm drains, culverts and surface-water systems engineered for Bengaluru's monsoon load profile.",
    tags: ["Drains", "Culverts", "Catch-pits"],
  },
  {
    code: "06",
    title: "Boundary Walls & Fencing",
    desc: "Site enclosures, RCC compound walls and perimeter fencing for industrial and residential plots.",
    tags: ["RCC", "Perimeter", "Industrial"],
  },
  {
    code: "07",
    title: "Rainwater Harvesting",
    desc: "Recharge pits, percolation wells and complete RWH systems compliant with BBMP/BWSSB norms.",
    tags: ["Recharge", "Percolation", "Compliance"],
  },
];

export const PROJECTS = [
  {
    client: "Phoenix Group",
    name: "Phoenix Mall of Asia",
    scope: "External Development",
    location: "Bengaluru",
    image:
      "https://images.unsplash.com/photo-1778961419992-d75e01ee53f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBnbGFzcyUyMGFyY2hpdGVjdHVyZSUyMGNvbW1lcmNpYWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3NzkzNTM4NTR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    client: "Phoenix Group",
    name: "Phoenix Market City",
    scope: "External Development",
    location: "Bengaluru",
    image:
      "https://images.pexels.com/photos/2606383/pexels-photo-2606383.jpeg",
  },
  {
    client: "House of Hiranandani",
    name: "Hiranandani — Bannerghatta Road",
    scope: "External Development",
    location: "Bengaluru",
    image:
      "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1600&q=80",
  },
  {
    client: "House of Hiranandani",
    name: "Hiranandani Villas",
    scope: "External Development",
    location: "Devanahalli, Bengaluru",
    image:
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1600&q=80",
  },
  {
    client: "SAP Labs",
    name: "SAP Labs Campus",
    scope: "External Development",
    location: "Whitefield, Bengaluru",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
  },
  {
    client: "Wipro",
    name: "Wipro SEZ — Kodathi Gate",
    scope: "External Development",
    location: "Bengaluru",
    image:
      "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1600&q=80",
  },
  {
    client: "BMRCL",
    name: "Bangalore Metro — Civil Works",
    scope: "Civil & External Development",
    location: "Bengaluru",
    image:
      "https://images.unsplash.com/photo-1474314881477-04c4aac40a0e?auto=format&fit=crop&w=1600&q=80",
  },
];

export const MACHINERY = [
  "Excavators & JCBs",
  "Rollers",
  "Paver Machines",
  "Concrete Cutters",
  "Vibrators",
  "Compactors",
  "Water Tankers",
  "Dumpers",
];

export const TEAM_ROLES = [
  "Civil Engineers",
  "Project Managers",
  "Site Supervisors",
  "Skilled Technicians",
  "Trained Workforce",
];

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "projects", label: "Projects" },
  { id: "capabilities", label: "Capabilities" },
  { id: "hse", label: "HSE" },
  { id: "contact", label: "Contact" },
];
